<div  (click)="view()">  <!--class="button mt-2" View-->
    <img loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
        class="img-28 pt-1" width="20px" />
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 48 48">
            <path fill="#ffc107" d="M33 22h-9.4L30 5H19l-6 21h8.6L17 45z" />
        </svg> -->
</div>